import React from "react";

export default function Vehicle_Data_Table_Jupiter(props) {
  let { data } = props;
  return (
    <>
      {data.length === 0
        ? <tr><td colSpan={10}>No data found</td></tr>
        : data.map((x, index) => {
          let lcharge_date=new Date(x.Last_charged_date)
          let Ldate = lcharge_date.getDate() + '/' + (lcharge_date.getMonth() + 1) + '/' + lcharge_date.getFullYear()
            return (
              <tr key={index}>
                <td scope="row">{index+1}</td>
                <td scope="row">{x.VIN}</td>
                <td scope="row">{x.CITY}</td>
                <td scope="row">{Ldate}</td>
                <td scope="row">{x.ChargeType}</td>
                <td scope="row">{x.soc_end}</td>
                <td scope="row">{x.Last_SOC_received}</td>
                <td scope="row">{x.Last_charge_day}</td>
              </tr>
            );
          })}
    </>
  );
}
